import React from 'react';
import { ApolloClient, InMemoryCache, createHttpLink, ApolloProvider } from '@apollo/client';
import PlanBuilderTemplateDetail from '../../../components/Admin/PlanBuilder/PlanBuilderTemplateDetail';

const httpLink = createHttpLink({
  uri: '/graphql',
  credentials: 'same-origin',
  headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content }
});

const client = new ApolloClient({ link: httpLink, cache: new InMemoryCache() });

const PlanBuilderTemplateDetailContainer = (props) => (
  <ApolloProvider client={client}>
    <PlanBuilderTemplateDetail {...props} />
  </ApolloProvider>
);

export default PlanBuilderTemplateDetailContainer;



